// extracted by mini-css-extract-plugin
export const form = "contact-form-module--form--55RyS";
export const button = "contact-form-module--button--1jVWV";
export const fieldWrapper = "contact-form-module--fieldWrapper--2Uxr-";
export const fieldCol = "contact-form-module--fieldCol--2xMMQ";
export const submitField = "contact-form-module--submitField--t3rSE";
export const spinner = "contact-form-module--spinner--a8Hav";